import {cn, cva} from 'platform/shared';

import {cloneElement, ReactNode} from 'react';

import {suffixTestId, TestIdProps} from 'shared/web';

import {flattenReactNode} from './flattenReactNode';

export interface BreadcrumbProps extends TestIdProps {
  children: ReactNode;
}

const breadcrumbListVariants = cva('flex');

export function Breadcrumb(props: BreadcrumbProps) {
  const flatChildren = flattenReactNode(props.children);

  const clones = flatChildren.map((child, index) =>
    cloneElement(child, {
      isLastChild: index === flatChildren.length - 1,
    })
  );

  return (
    <ol className={cn(breadcrumbListVariants())} data-testid={suffixTestId('breadcrumb', props)}>
      {clones}
    </ol>
  );
}
